import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: [
        't10h',
        't11',
        't11h',
        't12',
        't12h',
        't13',
        't13h',
        't14',
        't14h',
        't15',
        't16',
        't19',
        't22',
        't24',
        't28',
        't40',
        't52',
      ],
      radius: ['hair', 'tag', '2xs', 'xs', 'sm', 'ctl', 'plate', 'card', 'sheet', 'opt', 'bar'],
      tracking: ['title', 'label', 'link', 'kicker', 'eyebrow'],
      ease: ['app', 'press', 'close', 'stamp'],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
